import {Component, Inject, OnInit} from '@angular/core';

import {Entry, Group} from 'src/app/models';
import {SchedulesService} from 'src/app/services';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
    selector: 'app-weekly-schedule',
    templateUrl: './weekly-schedule.component.html',
    styleUrls: ['./weekly-schedule.component.scss']
})
export class WeeklyScheduleComponent implements OnInit {
    currentGroup: Group;
    dayValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    weeklySchedules = [];
    calendarRecipients = [];
    ready = false;
    override = false;
    lastWeekDay: any;
    recipientName: any;
    startYear: any;
    endYear: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private scheduleService: SchedulesService) {
        this.currentGroup = data.group;
    }

    ngOnInit() {
        this.data.week.forEach((day, i) => {
            let totalDuration = 0;
            day.coverage.forEach((participant, ii) => {
                if (participant.participant_id !== 0) {
                    const foundParticipant = this.data.recipients.find((recipient) => recipient.participant_id === participant.participant_id);
                    if (foundParticipant) {
                        this.data.week[i].coverage[ii].participant_name = foundParticipant.participant_name;
                        this.data.week[i].coverage[ii].display_time = totalDuration + ' - ' + (participant.duration + totalDuration);
                        totalDuration = participant.duration + totalDuration;
                    }
                }
            });
        });
        this.scheduleService.getScheduleByGroupID(this.currentGroup.id).subscribe((sched: Entry[]) => {
            this.weeklySchedules = sched;
            this.weeklySchedules.forEach((event) => { // TODO: use strict type instead of any
                event.starts = dayjs.tz(event.starts, this.data.timezone).format('MM/DD/YYYY h:mm A');
                event.ends = !event.ends ? null : dayjs.tz(event.ends, this.data.timezone).format('MM/DD/YYYY h:mm A');
                this.data.week.forEach((day) => {
                    day.coverage.forEach((participant) => {
                        event.participants.forEach((recipient) => {
                            if (recipient.participant_id === participant.participant_id) {
                                const indexOfPattern = participant.color.indexOf('patterned-for');
                                recipient.color = indexOfPattern === -1 ? participant.color : participant.color.substr(0, indexOfPattern);
                            }
                        });
                    });
                });
            });
            this.ready = true;
        });

        //calculate year for the header
        if(this.data.month == 1 && this.data.week[0].month == 12){
            this.endYear = this.data.year;
            this.startYear = this.data.year - 1;
        } else if (this.data.month == 12 && this.data.week[6].month == 1){
            this.endYear = this.data.year + 1;
            this.startYear = this.data.year;
        } else {
            this.endYear = this.data.year;
            this.startYear = this.data.year;
        }
    }

    calculateYear(month: any) {
        if(this.data.month == 1 && month == 12)
            return this.data.year - 1;
        if(this.data.month == 12 && month == 1)
            return this.data.year + 1;
        else
            return this.data.year;
    }
}
